export enum DailyLoadProcessStatus {
  PROCESSING = 'PROCESSING',
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED',
  NOT_STARTED = 'NOT_STARTED',
}

export default DailyLoadProcessStatus;
